'use client';

import { useState, useEffect } from 'react';
import { getNomeSistema } from '@/services/configuracoes';
import { resolveLogoSrc } from '@/lib/branding';

export interface Branding {
  nomeSistema: string;
  logoSrc: string | null;
}

/**
 * Nome e logo configurados em Configurações → Gerais / Aparência.
 * Endpoint público — funciona em telas sem autenticação.
 */
export function useBranding(): Branding {
  const [branding, setBranding] = useState<Branding>({
    nomeSistema: 'Sistema de Gestão',
    logoSrc: null,
  });

  useEffect(() => {
    const fetchBranding = async () => {
      try {
        const response = await getNomeSistema();
        setBranding({
          nomeSistema: response.nomeSistema || 'Sistema de Gestão',
          logoSrc: resolveLogoSrc(response.logoBase64, response.logoUrl),
        });
      } catch (error) {
        console.error('Erro ao buscar branding do sistema:', error);
      }
    };

    fetchBranding();
  }, []);

  return branding;
}
